import AppConstants from '../config/app.constants';

let RouteStatsService = function ($http, $q) {


    let getRouteShipmentDetail = ( vaultDate, routeId, locationId, messengerId=null ) => {
        return $http
            .get(AppConstants.api + '/route-stats/get-route-shipment-detail', {
                params: {
                    vaultDate, routeId, locationId, messengerId
                }
            })
            .then((res) => {
                return res.data
            })
    }
    let getShipmentTransactionHistory = (trackingId, routeId, locationId) => {
        return $http
        .get(AppConstants.api + '/route-stats/get-transaction-history', {
            params: {
                trackingId, routeId, locationId
            }
        })
        .then((res) => {
            return res.data
        })
    }


    return {
        getRouteShipmentDetail,
        getShipmentTransactionHistory
    };

};

RouteStatsService.$inject = ['$http', '$q']

export default RouteStatsService;


// WEBPACK FOOTER //
// ./client/app/services/route-stats.service.js